import { c } from "framer-motion/dist/types.d-Cjd591yU";

interface Props {
  className?: string;
  isEnabled: boolean;
}

const CheckBox: React.FC<Props> = ({ className, isEnabled }) => {
  return (
    <>
      {isEnabled ? (
        <img
          className={`${className}`}
          alt="체크박스 아이콘"
          src="/assets/icons/btn_Check box On.svg"
        />
      ) : (
        <img
          className={`${className}`}
          alt="체크박스 아이콘"
          src="/assets/icons/btn_Check box Off.svg"
        />
      )}
    </>
  );
};

export default CheckBox;
